import { AddCircle, Delete, Edit } from '@material-ui/icons';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useAddAssetDataMutation, useAddAssetTypeWithFieldsMutation, useDeleteAssetMutation, useGetAllAssetFieldsQuery, useGetAssetTypeListQuery, useLazyGetAssetsTypeByIDQuery, useUpdateAssetsTypeDataMutation } from '../../../features/vehicle/Assets/AssetsFieldSlice';
import { useCustomData } from '../../Sidebar/Permission';
import Spinner from '../../Spinner';
import TextField from '../../designSystem/TextField';
import errorHandler from '../../hooks/ErrorHanlder';
import VehicleWrapper from './VehicleWrapper';

const AssetsType = () => {
    const [permission] = useCustomData()
    const { register, setValue, handleSubmit, formState: { errors }, reset } = useForm();
    const [deleteId, setDeleteId] = useState()
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([])
    const [checkedValue, setCheckedValue] = useState([]);
    const [inputText, setInputText] = useState('');
    const [AssetsField, setAssetField] = useState('');
    const [show, setShow] = useState(false);
    const [disable, setDisable] = useState(false)
    const [checkedData, setCheckedData] = useState({})
    const [addAssetData] = useAddAssetDataMutation();
    const { data: getAllAssetFields, refetch: getData } = useGetAllAssetFieldsQuery();
    const [addAssetTypeWithFields] = useAddAssetTypeWithFieldsMutation()
    const { data: table, isLoading, refetch } = useGetAssetTypeListQuery();
    const tableList = table?.data;
    const [setRowId, getAssetTypeData] = useLazyGetAssetsTypeByIDQuery()
    const [updateAssetsType] = useUpdateAssetsTypeDataMutation();
    const [deleteVehicleInventorydata] = useDeleteAssetMutation();


    useEffect(() => {
        setAssetField(getAllAssetFields?.data)
    }, [getAllAssetFields, list])

    const addList = async (inputText) => {
        try {
            if (!inputText) {
                return
            }
            let apiData = {
                "assetFieldName": inputText
            }
            setList([...list, inputText])
            await addAssetData(apiData)
            getData()
        }
        catch {
            toast.warning("An Error Occured!", { position: "top-center" })
        }
    }
    const handleClose = async () => {
        try {
            setOpen(false);
            await deleteVehicleInventorydata(deleteId).unwrap()
            toast.success("Asset Deleted Succesfully!", { position: "top-center" })
            refetch()
        }
        catch (error) {
            errorHandler(error)
        }
    };

    const checkHandler = (e, listItem) => {
        try {
            const updatedCheckedData = { ...checkedData };
            const updatedCheckedValue = [...checkedValue];

            if (e.target.checked) {
                updatedCheckedData[e.target.name] = true;
                // Only add unique assetFieldId to the checkedValue array
                if (!updatedCheckedValue.some(item => item.assetFieldId === listItem?.assetFieldId)) {
                    updatedCheckedValue.push({ assetFieldId: listItem?.assetFieldId });
                }
            } else {
                updatedCheckedData[e.target.name] = false;
                const indexToRemove = updatedCheckedValue.findIndex(
                    (data) => data?.assetFieldId === listItem?.assetFieldId
                );
                if (indexToRemove > -1) {
                    updatedCheckedValue.splice(indexToRemove, 1);
                }
            }

            setCheckedData(updatedCheckedData);
            setCheckedValue(updatedCheckedValue);
        } catch {
            toast.warning("An Error Occured!", {
                position: "top-center",
            });
        }
    };

    useEffect(() => {
        if (getAssetTypeData?.data?.data?.fieldDetails?.length > 0) {
            const checkedFields = {};
            const checkedValues = [];

            getAssetTypeData?.data?.data?.fieldDetails?.forEach((d) => {
                if (d?.fieldName !== null) {
                    checkedFields[d?.assetFieldName] = true;
                    checkedValues.push({ assetFieldId: d?.assetFieldId });
                }
            });

            setCheckedData(checkedFields);
            setCheckedValue(checkedValues);
        } else {
            setCheckedData({});
            setCheckedValue([]);
        }
    }, [getAssetTypeData]);

    const resetStates = () => {
        setCheckedData({})
        setCheckedValue([]);
        reset({ asset_type: "", checkedValue: "" });
        setShow(false)
        setDisable(false)
    }

    const onSubmit = async (data) => {
        try {
            const newData = {
                "assetTypeDescription": data?.asset_type,
                "fieldDetails": checkedValue
            }
            await addAssetTypeWithFields(newData).unwrap()
            refetch()
            resetStates()
            toast.success("New Asset Added!", { position: "top-center" })
        }
        catch (error) {
            errorHandler(error)
        }
    }

    const update = async () => {
        try {
            const updateData = {
                "assetTypeId": getAssetTypeData?.data?.data?.assetTypeId,
                "assetTypeDescription": getAssetTypeData?.data?.data?.assetTypeDescription,
                "fieldDetails": checkedValue
            }

            await updateAssetsType(updateData).unwrap()
            await refetch()
            getData()
            resetStates()
            toast.success("Asset updated Succesfully!", {
                position: "top-center",
            })
        }
        catch (error) {
            errorHandler(error)
        }
    }

    const columns = [
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 120,
            disableClickEventBubbling: true,
            renderCell: (data) => {
                const onClick = (e) => {
                    e.stopPropagation();
                    setRowId(data?.id)
                    setValue("asset_type", data?.row?.Asset_Type)
                    setDisable(true)
                    setShow(true);

                    // Reset checked fields when selecting a new asset
                    setCheckedValue([]);
                    setCheckedData({});
                };
                const onRemove = (data) => {
                    setDeleteId(data?.id)
                    setOpen(true);
                };
                return (
                    <>
                        <div className="action_btn">
                            {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Update') !== -1 ?
                                <span className="edit_btn" onClick={onClick}><Edit /></span>
                                : <span className="edit_btn disable"><Edit /></span>
                            }
                            {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Delete') !== -1 ?
                                <span className="del_btn" onClick={() => onRemove(data)}><Delete /></span> :
                                <span className="del_btn disable"><Delete /></span>}
                        </div>
                        <div>
                            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                                <DialogTitle id="alert-dialog-title">
                                    Delete Confirmation
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete this row?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button className="btn-secondary" onClick={() => { setOpen(false); }}>Cancel</Button>
                                    <Button className="btn-primary" onClick={() => { handleClose(); }} > Confirm</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </>
                )
            },
        },
        { field: "Asset_Type", headerName: "Asset Type", width: 120, },
    ];

    const rows = tableList?.map((data) => {
        return {
            id: data?.assetTypeId,
            Asset_Type: data?.assetTypeDescription
        }
    }) || []
    const submitHandler = show
        ? handleSubmit(update)
        : handleSubmit(onSubmit);

    return (

        <>
            {isLoading && <Spinner />}
            <VehicleWrapper
                onCancel={resetStates}
                isEdit={show}
                onSubmit={submitHandler}
                rows={rows}
                columns={columns}
                listTitle="Add Assets Type"
                label="Select the field you would like to add for the item descriptions">

                <VehicleWrapper.SectionOne>
                    <TextField style={{ maxWidth: "300px" }} label="Add a Asset Type" {...register('asset_type', { required: 'Field is required', pattern: /^[^-\s][a-zA-Z0-9_\s-]+$/ })} disabled={disable} error={errors?.asset_type?.message} />
                </VehicleWrapper.SectionOne>

                <Row >
                    <Col sm={9}></Col>
                    <Col sm={3}>
                        <Row>
                            <Col sm={8}>
                                <div className="form-floating">
                                    <Form.Control type="text" autoComplete="off" placeholder="Add more field" name="Addmorefield"
                                        onChange={(e) => { setInputText(e.target.value) }} value={inputText} />
                                    <label htmlFor="Add more field">Add more field</label>
                                </div>
                            </Col>
                            <Col sm={4}>
                                {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Add') !== -1 ?
                                    <Button className="btn btn-secondary" onClick={() => { addList(inputText); setInputText("") }} ><AddCircle /> Add </Button>
                                    : <Button className="btn btn-secondary disable"><AddCircle /> Add </Button>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div className="mt-4 discriptionBox">
                    {AssetsField && AssetsField?.map((listItem, id) => {
                        return (
                            <div key={id} className="form-check form-check-inline boxHover">
                                <div className="form-group">
                                    <input className="form-check-input" type="checkbox" key={checkedData[listItem?.assetFieldName]} checked={checkedData[listItem?.assetFieldName]} value={listItem?.assetFieldId}
                                        name={listItem?.assetFieldName} onChange={(e) => checkHandler(e, listItem)} />
                                    <label className="form-check-label" htmlFor="inlineCheckbox1"> {listItem?.assetFieldName}</label>
                                </div>
                            </div>
                        )
                    }
                    )}
                </div>
            </VehicleWrapper>
        </>
    )
}

export default AssetsType;
